export default {
    namespaced: true,
    state: {
        page: "home",

        playVideoAgency: false,
        resetVideoAgency: false,

        playVideoHome: true,
        pauseVideoHomeByUser: false,
        resetVideoHome: false,

        playVideoRef: false,
        pauseVideoRefByUser: false,
        resetVideoRef: false,
        videoRefLoaded: false,

        loaderWebsite: true,

        // Modal menu
        displayNav: false,
        // Modal generique
        modal: {
            display: false,
            name: null,
            content: null,
            type: null,
            index: null,
        },

        positionSticky: true,
        newRefModal: false,
        filters: {
            fr: [...new Set(refs_fr.flatMap((item) => item.tags))],
            en: [...new Set(refs_en.flatMap((item) => item.tags))],
        },
        filter: "",
        zones_offers: [
            {
                content: {
                    fr: "Notre équipe pluridisciplinaire a un objectif : la réussite de votre projet !",
                    en: "Our multidisciplinary team has a goal: the success of your project!",
                },
                pos: {
                    sm: {
                        width: 40,
                        height: 20,
                        top: 70,
                        left: 0,
                    },
                    lg: {
                        width: 19,
                        height: 30,
                        top: 40,
                        left: 0,
                    },
                },
            },
            {
                content: {
                    fr: "Pour une bonne formation, 3 points clés : le scénario, le scénario, le scénario.",
                    en: "For a good training, 3 key points: the scenario, the scenario, the scenario.",
                },
                pos: {
                    sm: {
                        width: 20.5,
                        height: 10,
                        top: 80.5,
                        left: 50,
                    },
                    lg: {
                        width: 10,
                        height: 30,
                        top: 40,
                        left: 19.5,
                    },
                },
            },
            {
                content: {
                    fr: "Nous avons toute une palette de talents pour créer un univers graphique mémorable !",
                    en: "We have a whole range of talents to create a memorable graphic universe!",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 19.5,
                        top: 50,
                        left: 0,
                    },
                    lg: {
                        width: 20,
                        height: 20,
                        top: 70.5,
                        left: 19.5,
                    },
                },
            },
            {
                content: {
                    fr: "Responsive ? Multilingue ? Adaptive ? Nous intégrons tous les challenges.",
                    en: "Responsive?Multilingual?Adaptive?We integrate all the challenges.",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 10,
                        top: 59.5,
                        left: 20.5,
                    },
                    lg: {
                        width: 20,
                        height: 20,
                        top: 60.5,
                        left: 40,
                    },
                },
            },
            {
                content: {
                    fr: "Pour développer des fonctionnalités ou applications natives, les codeurs sont là !",
                    en: "To develop native features or applications, the coders are there!",
                },
                pos: {
                    sm: {
                        width: 30,
                        height: 10,
                        top: 70,
                        left: 40.5,
                    },
                    lg: {
                        width: 20,
                        height: 18.5,
                        top: 81,
                        left: 50.5,
                    },
                },
            },
            {
                content: {
                    fr: "Efficacité, convivialité, mais moins d'empreinte …",
                    en: "Efficiency, conviviality, but less imprint …",
                },
                pos: {
                    sm: {
                        width: 20.5,
                        height: 10,
                        top: 70,
                        left: 71,
                    },
                    lg: {
                        width: 10,
                        height: 28,
                        top: 69.5,
                        left: 71,
                    },
                },
            },
            {
                content: {
                    fr: "Si une image vaut mille mots, que dire de la vidéo ! Notre équipe est prête à se mettre en mouvement !",
                    en: "If an image is worth a thousand words, what about the video!Our team is ready to set in motion!",
                },
                pos: {
                    sm: {
                        width: 29,
                        height: 20,
                        top: 49.5,
                        left: 50.5,
                    },
                    lg: {
                        width: 20.5,
                        height: 18.5,
                        top: 50.5,
                        left: 60.5,
                    },
                },
            },
            {
                content: {
                    fr: "Nos formations sont compatibles avec toutes les LMS du marché… et le nôtre !",
                    en: "Our training courses are compatible with all LMS on the market… and ours!",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 20,
                        top: 39,
                        left: 30,
                    },
                    lg: {
                        width: 9.5,
                        height: 31,
                        top: 28.5,
                        left: 50.5,
                    },
                },
            },
            {
                content: {
                    fr: "L'évaluation est au cœur de toute bonne stratégie de formation ! Vrai ou Faux ?",
                    en: "The evaluation is at the heart of any good training strategy!True or false ?",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 10,
                        top: 39,
                        left: 50.5,
                    },
                    lg: {
                        width: 9.5,
                        height: 21,
                        top: 28.5,
                        left: 60.5,
                    },
                },
            },
            {
                content: {
                    fr: "Rien d'artificiel dans l'IA, à condition de s'en servir intelligemment !",
                    en: "Nothing artificial in AI, provided you use it intelligently!",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 20,
                        top: 29.5,
                        left: 10,
                    },
                    lg: {
                        width: 20,
                        height: 20,
                        top: 28.5,
                        left: 30,
                    },
                },
            },
            {
                content: {
                    fr: "Neurosciences, 3D temps réel, disruption : notre Lab est fait de nouvelles expériences.",
                    en: "Neuroscience, 3D real time, disruption: our lab is made of new experiences.",
                },
                pos: {
                    sm: {
                        width: 31,
                        height: 10,
                        top: 28.5,
                        left: 30,
                    },
                    lg: {
                        width: 30,
                        height: 18,
                        top: 9.5,
                        left: 40,
                    },
                },
            },
            {
                content: {
                    fr: "Porter la créativité de la naissance à l'aboutissement du projet, c'est dans notre ADN !",
                    en: "Wearing the creativity of birth to the outcome of the project is in our DNA!",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 10,
                        top: 39,
                        left: 70.5,
                    },
                    lg: {
                        width: 10,
                        height: 30,
                        top: 19.5,
                        left: 70.5,
                    },
                },
            },
            {
                content: {
                    fr: "Notre empathie est la clé pour nous adapter aux personas et aux profils de vos stagiaires.",
                    en: "Our empathy is the key to adapting us to the personas and profiles of your interns.",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 20,
                        top: 49.5,
                        left: 80,
                    },
                    lg: {
                        width: 9.5,
                        height: 16.5,
                        top: 50.5,
                        left: 81.5,
                    },
                },
            },
            {
                content: {
                    fr: "Sous forme de jeu immersif ou de storytelling interactif, nous saurons trouver le bon état de flow.",
                    en: "In the form of an immersive game or interactive storytelling, we will find the good condition of Flow.",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 10,
                        top: 28.5,
                        left: 70.5,
                    },
                    lg: {
                        width: 18,
                        height: 30,
                        top: 19.5,
                        left: 81,
                    },
                },
            },
            {
                content: {
                    fr: "Pour vous aider à réussir le lancement de vos formations, demandez-nous la lune !",
                    en: "To help you succeed in launching your training, ask us for the moon!",
                },
                pos: {
                    sm: {
                        width: 9,
                        height: 16,
                        top: 25.5,
                        left: 90.5,
                    },
                    lg: {
                        width: 10,
                        height: 19,
                        top: 0,
                        left: 80,
                    },
                },
            },
            {
                content: {
                    fr: "Le numérique responsable, c'est important !",
                    en: "Responsible digital technology is important!",
                },
                pos: {
                    sm: {
                        width: 19.5,
                        height: 19,
                        top: 80.5,
                        left: 80,
                    },
                    lg: {
                        width: 9.5,
                        height: 19,
                        top: 67.5,
                        left: 90,
                    },
                },
            },
        ],
        games: {
            fr: [
                {
                    title: "Lorem ipsum dolor sit amet",
                    desc: "<p>At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.</p>",
                    src: "labyrinthe/story.html",
                },
            ],
            en: [
                {
                    title: "Lorem ipsum dolor sit amet",
                    desc: "<p>At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.</p>",
                    src: "labyrinthe/story.html",
                },
            ],
        },
        page_fv: {
            functionality: {
                fr: [
                    {
                        title: "Gérez simplement votre base de questions",
                        desc: "<p><span>Créez facilement vos questions sous forme de QCM, QCU, questions ouvertes</span>, activités d'association, textes à trous et exercices de légende d'image ou de glisser-déposer.</p><p>Mettez en place un workflow de validation des questions pour assurer leur validité dans le temps.</p><p>Retrouvez vos questions dans la base de données et sélectionnez celles à intégrer dans vos évaluations.</p>",
                        img: "page_fv/Formavisa_gerer_02.jpg",
                    },
                    {
                        title: "Paramétrage et automatisation des évaluations",
                        desc: "<p>Construisez vos évaluations formatives, sommatives et diagnostiques à partir des questions en base.</p><p>Choisissez les questions à intégrer avec un paramétrage très fin (ordre des questions, ordre des propositions, pondération, système de notation).</p><p>Définissez la possibilité de passer des évaluations de rattrapage.</p><p>Paramétrez vos sessions d'évaluations (ouverture automatique ou manuelle, inscription de la population concernée, envoi de convocations, de rappels...).</p><p>Automatisez vos sessions à fréquences régulières.</p>",
                        img: "page_fv/Formavisa_parametrage.jpg",
                    },
                    {
                        title: "Générez des questions avec l'IA",
                        desc: "<p><span>Générez des propositions de questions à partir de tout type de documents.</span></p><p><span>Paramétrez le nombre de questions et le niveau de difficulté souhaité.</span></p><p>Sélectionnez les questions à garder et à intégrer dans le workflow de validation.</p><p>Historisez les demandes de génération par IA et les documents associés.</p>",
                        img: "page_fv/Formavisa_generer.jpg",
                    },
                    {
                        title: "Outil statistique",
                        desc: "<p>Accédez à <span>toutes les données</span> de suivi selon vos besoins.</p><p><span>Suivez les statistiques globales :</span></p><ul><li>individuelles et par groupe de collaborateurs</li><li>par évaluation et jusqu'au niveau de chaque question</li></ul><p>Suivez l'évolution des résultats dans le temps, par utilisateur ou par question.</p>",
                        img: "page_fv/Formavisa_outil_02.jpg",
                    },
                ],
                en: [
                    {
                        title: "Simply manage your questions",
                        desc: "<p><span>Easily create your questions in the form of MCQs, QCU, Open questions</span>, Association Activities, TEXTS TO HOLS AND Image legend exercises or to drag and drop.</p><p>set up a work validation workflow to ensure their validity in time.</p><p>Find your questions in the database and select those to integrate in your assessments.</p>",
                        img: "page_fv/Formavisa_gerer_02.jpg",
                    },
                    {
                        title: "Configuration and automation of evaluations",
                        desc: "<p>Build your formative, summative and diagnostic assessments from the basis questions.</p><p>Choose the questions to integrate with a very fine configuration (Question order, order of proposals, weighting, rating system).</p><p>Define the possibility of passing catch -up assessments.</p><p>set up your evaluation sessions (automatic or manual opening, registration of the population concerned, sending of summons, reminders...).</p><p>Automatize your sessions with regular frequencies.</p>",
                        img: "page_fv/Formavisa_parametrage.jpg",
                    },
                    {
                        title: "Generate questions with AI",
                        desc: "<p><span>Generate questions from questions from all types of documents.</span></p><p><span>Configure the number of questions and the desired level of difficulty.</span></p><p>Select the questions to keep and integrate into the validation workflow.</p><p>Historize requests for generation by AI and associated documents.</p>",
                        img: "page_fv/Formavisa_generer.jpg",
                    },
                    {
                        title: "Statistical tool",
                        desc: "<p> Access <span>all monitoring data</span> according to your needs.</p><p><span>Follow the global statistics:</span></p><ul><li>individual and by group of collaborators</li><li>by evaluation and up to the level of each question</li></ul><p>Follow the evolution of results in time, by user or by question.</p>",
                        img: "page_fv/Formavisa_outil_02.jpg",
                    },
                ],
            },
            extra: {
                fr: [
                    {
                        title: "Conception de vos évaluations",
                        desc: "<p>Notre expérience dans le domaine de l'évaluation et de la formation digitale nous permet de vous proposer un service d'accompagnement.</p><p>Notre équipe d'ingénieurs pédagogiques peut rédiger pour vous un pool de questions sur la thématique de votre choix.</p><p>La typologie, la difficulté et la progression des questions seront définies en fonction de sujet et du contexte.</p>",
                        img: "page_fv/Formavisa_conception.jpg",
                    },
                    {
                        title: "Compatibilité ELearning",
                        desc: "<p>Vous possédez une habilitation ou une formation développée dans un outil auteur ? Rassurez-vous, <span>Formavisa est compatible avec tous vos contenus</span> au format SCORM 1.2 ou 2004, xAPI et répond à toutes les normes en terme de suivi des données de complétion.</p>",
                        img: "page_fv/Formavisa_compatibilite.jpg",
                    },
                    {
                        title: "Personnalisation et évolutivité",
                        desc: "<p>Chez haikara notre ADN c'est le sur-mesure.</p><p>FormaVisa est une plateforme propriétaire entièrement développée par haikara.</p><p>C'est  pourquoi nous pouvons non seulement personnaliser FormaVisa pour vous (adaptation graphique des interfaces à votre charte, intégration à votre ecosystème informatique), mais aussi développer des fonctionnalités spécifiquement pour vous afin d'être au plus proche de votre besoin.</p>",
                        img: "page_fv/Formavisa_personnalisation.jpg",
                    },
                ],
                en: [
                    {
                        title: "Design of your assessments",
                        desc: "<p> Our experience in the field of evaluation and digital training allows us to offer you a support service.</p><p>Our team of educational engineers can write for you a pool of questions about the theme of your choice.</p><p>The typology, difficulty and progression of questions will be defined according to subject and context.</p>",
                        img: "page_fv/Formavisa_conception.jpg",
                    },
                    {
                        title: "Elearning compatibility",
                        desc: "<p>Do you have an authorization or training developed in an author tool?Rest assured,<span>Formavisa is compatible with all your content</span> In SCORM 1.2 or 2004 format, XAPI and meets all standards in terms of completion data monitoring.</p>",
                        img: "page_fv/Formavisa_compatibilite.jpg",
                    },
                    {
                        title: "Personalization and scalability",
                        desc: "<p>At Haikara our DNA it is tailor-made.</p><p>Formavisa is a owner platform entirely developed by Haikara.</p><p>This is why we can not only personalize formavisa for you (graphic adaptation of interfaces to your charter, integration into your computer ecosystem), but also develop features specifically for you in order to be as close as possible to your need.</p>",
                        img: "page_fv/Formavisa_personnalisation.jpg",
                    },
                ],
            },
        },
        fundamentals: {
            fr: [
                {
                    title: "Curieux",
                    desc: `<p><strong>Curieux de nature</strong>, nous accueillons chaque sujet avec enthousiasme, quel que soit votre métier.</p>`,
                    img: "swipper/Curieux.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Conseil",
                    desc: `<p><strong>Chacune de vos demandes fait l'objet d'une étude personnalisée</strong>, afin de vous offrir des recommandations en accord avec votre vision, votre budget et votre délai.</p>`,
                    img: "swipper/Conseil.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Dispositif",
                    desc: `<p><strong>Le séquencement de la formation</strong>, structurée en phases d'apprentissage rythmées, narratives et interactives, maintient l'attention du stagiaire en suscitant une curiosité continue, dans une immersion en plein écran favorisant la concentration.</p>`,
                    img: "swipper/Dispositif.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Pédagogie",
                    desc: `<p><strong>Notre pédagogie</strong>, au service de vos collaborateurs, s'étoffe de simulations de cas d'usages professionnels réalistes, écrits pour atteindre efficacement vos objectifs opérationnels, dans un ton empathique et chaleureux.</p>`,
                    img: "swipper/Pedagogie.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Design",
                    desc: `<p><strong>Des designs sur-mesure</strong> sont créés pour chaque écran afin de produire un résultat soigné en accord avec vos objectifs de communication interne, dans une expérience d'apprentissage alignée sur les marqueurs graphiques de votre entité.</p>`,
                    img: "swipper/Design.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Réalisation",
                    desc: `<p><strong>Nos réalisations</strong> sont portées par des storytellings, animés et enrichis d’interactions 3D, d’activités disruptives ou de séquences vidéo mettant en scène des avatars photoréalistes en IA Gen habités par des voix de comédiens professionnels.</p>`,
                    img: "swipper/Realisation.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Développement",
                    desc: `<p><strong>Vos demandes spécifiques</strong> font l'objet de développements inédits pour répondre à vos attentes, à la pointe de l'innovation pour tout type de diffusion, sur votre LMS ou au format applicatif. </p>`,
                    img: "swipper/Developpement.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Déploiement",
                    desc: `<p>Nos modules, construits avec <strong>des technologies éprouvées</strong> et maintenues, permettent le déploiement mondial de vos formations dans de multiples versions localisées à un coût maîtrisé.</p>`,
                    img: "swipper/Deploiement.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Accompagnement",
                    desc: `<p><strong>L'exigence de qualité</strong>, qui est notre ADN, est à l'image de notre accompagnement continu tout au long du projet.</p>`,
                    img: "swipper/Accompagnement.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Notre ADN",
                    desc: `<p><strong>Pour chaque projet, haikara porte l'ambition de créer un parcours efficace, original, inclusif et durable, qui atteint ses objectifs.</strong></p>`,
                    img: "swipper/ADN.png",
                    color: "#1e1e3b"
                },
            ],
            en: [
                {
                    title: "Curious",
                    desc: `<p><strong>Curious by nature</strong>, we approach every topic with enthusiasm, no matter your profession.</p>`,
                    img: "swipper/Curieux.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Consulting",
                    desc: `<p><strong>Each of your requests receives a personalized analysis</strong> to provide recommendations aligned with your vision, budget, and timeline.</p>`,
                    img: "swipper/Conseil.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Device",
                    desc: `<p><strong>The sequencing of the training</strong>, structured into paced, narrative, and interactive learning phases, maintains the learner's attention by sparking continuous curiosity, within a full-screen immersive experience that fosters focus.</p>`,
                    img: "swipper/Dispositif.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Pedagogy",
                    desc: `<p><strong>Our pedagogy</strong>, designed for your teams, incorporates realistic simulations of professional use cases, crafted to effectively achieve your operational goals, in an empathetic and warm tone.</p>`,
                    img: "swipper/Pedagogie.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Design",
                    desc: `<p><strong>Custom-made designs</strong> are created for each screen to deliver a polished result that aligns with your internal communication goals, within a learning experience that reflects your brand's graphic identity.</p>`,
                    img: "swipper/Design.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Production",
                    desc: `<p><strong>Our productions</strong> are driven by narrative storytelling, animated and enriched with 3D interactions, disruptive activities, or video sequences featuring photorealistic AI-generated avatars voiced by professional actors.</p>`,
                    img: "swipper/Realisation.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Development",
                    desc: `<p><strong>Your specific requests</strong> are addressed through unique developments, staying at the forefront of innovation for any type of distribution—whether on your LMS or in application format.</p>`,
                    img: "swipper/Developpement.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Deployment",
                    desc: `<p>Our modules, built with <strong>proven and supported technologies</strong>, enable global deployment of your training in multiple localized versions at a controlled cost.</p>`,
                    img: "swipper/Deploiement.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Support",
                    desc: `<p><strong>Our commitment to quality</strong>, which defines our DNA, reflects in the continuous support we provide throughout the project.</p>`,
                    img: "swipper/Accompagnement.png",
                    color: "#1e1e3b"
                },
                {
                    title: "Our DNA",
                    desc: `<p><strong>For each project, haikara is driven by the ambition to create an effective, original, inclusive, and sustainable learning journey that fulfills its goals.</strong></p>`,
                    img: "swipper/ADN.png",
                    color: "#1e1e3b"
                },
            ],
        },
        page_agency: {
            fr: [
                {
                    title: "Nos fondamentaux pour la réalisation de formations digitales.",
                    desc: `<p><strong>Curieux de nature</strong>, nous accueillons chaque sujet avec enthousiasme, quel que soit votre métier.</p>
                            <p><strong>Chacune de vos demandes fait l'objet d'une étude personnalisée</strong>, afin de vous offrir des recommandations en accord avec votre vision, votre budget et votre délai.</p>
                            <p><strong>Notre pédagogie</strong>, au service de vos collaborateurs, s'étoffe de simulations de cas d'usages professionnels réalistes, écrits pour atteindre efficacement vos objectifs opérationnels, dans un ton empathique et chaleureux.</p>
                            <p><strong>Le séquencement de la formation</strong>, structurée en phases d'apprentissage rythmées, narratives et interactives, maintient l'attention du stagiaire en suscitant une curiosité continue, dans une immersion en plein écran favorisant la concentration.</p>
                            <p><strong>Des designs sur-mesure</strong> sont créés pour chaque écran afin de produire un résultat soigné en accord avec vos objectifs de communication interne, dans une expérience d'apprentissage alignée sur les marqueurs graphiques de votre entité.</p>
                            <p><strong>Nos réalisations</strong> sont portées par des storytellings narratifs, animés et enrichis de d'interactions 3D, d'activités disruptives ou de séquences vidéo mettant en scène des avatars photoréalistes en IA Gen habités par des voix de comédiens professionnels.</p>
                            <p><strong>Vos demandes spécifiques</strong> font l'objet de développements inédits pour répondre à vos attentes, à la pointe de l'innovation pour tout type de diffusion, sur votre LMS ou au format applicatif.</p>
                            <p>Nos modules, construits avec <strong>des technologies éprouvées</strong> et maintenues, permettent le déploiement mondial de vos formations dans de multiples versions localisées à un coût maîtrisé.</p>
                            <p><strong>L'exigence de qualité</strong>, qui est notre ADN, est à l'image de notre accompagnement continu tout au long du projet.</p>
                            <p><strong>Pour chaque projet, haikara porte l'ambition de créer un parcours efficace, original, inclusif et durable, qui atteint ses objectifs.</p>
                            <p><a href="#" class="lk-contact">Contactez-nous !</a></p>`,
                    img: "page_fv/Formavisa_gerer_02.jpg",
                },
            ],
            en: [
                {
                    title: "Our fundamentals for delivering digital training.",
                    desc: `<p><strong>Naturally curious</strong>, we welcome every topic with enthusiasm, regardless of your profession.</p>
                            <p><strong>Each of your requests is subject to a personalized study</strong>, in order to offer you recommendations aligned with your vision, budget, and deadline.</p>
                            <p><strong>Our teaching method</strong>, designed to serve your employees, is enhanced with realistic professional use case simulations, written to effectively achieve your operational objectives, in a warm and empathetic tone.</p>
                            <p><strong>The training sequence</strong>, structured into rhythmic, narrative, and interactive learning phases, maintains the trainee's attention by arousing continuous curiosity, in a full-screen immersion that promotes concentration.</p>
                            <p><strong>Custom designs</strong> are created for each screen to produce a polished result aligned with your internal communication objectives, in a learning experience aligned with your organization's graphic design.</p>
                            <p><strong>Our creations</strong> are driven by narrative storytelling, animated and enriched with 3D interactions, disruptive activities, or video sequences featuring photorealistic AI avatars inhabited by the voices of professional actors.</p>
                            <p><strong>Your specific requests</strong> are the subject of unique developments to meet your expectations, at the cutting edge of innovation for any type of delivery, on your LMS or in application format.</p>
                            <p>Our modules, built with <strong>proven and maintained technologies</strong>, allow the global deployment of your training courses in multiple localized versions at a controlled cost.</p>
                            <p><strong>The demand for quality</strong>, which is our DNA, reflects our ongoing support throughout the project.</p>
                            <p><strong>For each project, Haikara strives to create an effective, original, inclusive, and sustainable journey that achieves its objectives.</p>
                            <p><a href="#" class="lk-contact">Contact us!</a></p>`,
                    img: "page_fv/Formavisa_gerer_02.jpg",
                },
            ],
        },
    },
    mutations: {
        DISPLAY_PAGE(state, payload) {
            state.page = payload;
        },
        DISPLAY_NAV(state, payload) {
            state.displayNav = payload;
        },
        DISPLAY_MODAL(state, payload) {
            if (!payload.display) {
                state.modal.name = null;
                state.modal.content = null;
            } else {
                state.modal.name = payload.name;
                state.modal.content = payload.content;
            }

            state.modal.type = payload.type ? payload.type : null;
            state.modal.index = payload.index !== undefined && payload.index !== null ? payload.index : null;

            state.modal.display = payload.display;
        },
        SET_FILTER(state, payload) {
            state.filter = payload;
        },
        SET_PLAY_VIDEO_AGENCY(state, payload) {
            state.playVideoAgency = payload;
        },
        SET_RESET_VIDEO_AGENCY(state, payload) {
            state.resetVideoAgency = payload;
        },
        SET_PLAY_VIDEO_HOME(state, payload) {
            state.playVideoHome = payload;
        },
        SET_PAUSE_VIDEO_HOME_BY_USER(state, payload) {
            state.pauseVideoHomeByUser = payload;
        },
        SET_RESET_VIDEO_HOME(state, payload) {
            state.resetVideoHome = payload;
        },
        SET_PLAY_VIDEO_REF(state, payload) {
            state.playVideoRef = payload;
        },
        SET_PAUSE_VIDEO_REF_BY_USER(state, payload) {
            state.pauseVideoRefByUser = payload;
        },
        SET_RESET_VIDEO_REF(state, payload) {
            state.resetVideoRef = payload;
        },
        SET_VIDEO_REF_LOADED(state, payload) {
            state.videoRefLoaded = payload;
        },
        SET_POSITION_STICKY(state, payload) {
            state.positionSticky = payload;
        },
        SET_NEW_REF_MODAL(state, payload) {
            state.newRefModal = payload;
        },
        SET_LOADER_WEBSITE(state, payload) {
            state.loaderWebsite = payload;
        },
    },
    actions: {
        setPage(context, payload) {
            context.commit("DISPLAY_PAGE", payload);
        },
        displayNav(context, payload) {
            context.commit("DISPLAY_NAV", payload);
        },
        displayModal(context, payload) {
            context.commit("DISPLAY_MODAL", payload);
        },
        setFilter(context, payload) {
            context.commit("SET_FILTER", payload);
        },
        setPlayVideoAgency(context, payload) {
            context.commit("SET_PLAY_VIDEO_AGENCY", payload);
        },
        setResetVideoAgency(context, payload) {
            context.commit("SET_RESET_VIDEO_AGENCY", payload);
        },
        setPlayVideoHome(context, payload) {
            context.commit("SET_PLAY_VIDEO_HOME", payload);
        },
        setPauseVideoHomeByUser(context, payload) {
            context.commit("SET_PAUSE_VIDEO_HOME_BY_USER", payload);
        },
        setResetVideoHome(context, payload) {
            context.commit("SET_RESET_VIDEO_HOME", payload);
        },
        setPlayVideoRef(context, payload) {
            context.commit("SET_PLAY_VIDEO_REF", payload);
        },
        setPauseVideoRefByUser(context, payload) {
            context.commit("SET_PAUSE_VIDEO_REF_BY_USER", payload);
        },
        setResetVideoRef(context, payload) {
            context.commit("SET_RESET_VIDEO_REF", payload);
        },
        setVideoRefLoaded(context, payload) {
            context.commit("SET_VIDEO_REF_LOADED", payload);
        },
        setPositionSticky(context, payload) {
            context.commit("SET_POSITION_STICKY", payload);
        },
        setNewRefModal(context, payload) {
            context.commit("SET_NEW_REF_MODAL", payload);
        },
        setLoaderWebsite(context, payload) {
            context.commit("SET_LOADER_WEBSITE", payload);
        },
    },
    getters: {
        getRefs: () => (local) => {
            return local === "fr" ? refs_fr : refs_en;
        },
        getRef: () => (local, idx) => {
            return local === "fr" ? refs_fr.find(ref => ref.id == idx) : refs_en.find(ref => ref.id == idx);
        },
    },
};
